import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProjectsComponent} from './projects.component';
import {ProjectCreateEditComponent} from './project-create-edit/project-create-edit.component';
import {ProjectsListComponent} from './projects-list/projects-list.component';
import {ProjectViewComponent} from './project-view/project-view.component';
import {RouterModule} from '@angular/router';
import {ProjectsRoutingModule} from './projects-routing.module';
import {DataTablesModule} from 'angular-datatables';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgSelect2Module} from 'ng-select2';
import {InlineSVGModule} from 'ng-inline-svg';
import {NgbAlertModule, NgbDropdownModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {SharedModule} from '../../shared/shared.module';
import {MatTabsModule} from '@angular/material/tabs';
import {NgWizardModule} from 'ng-wizard';
import {NgApexchartsModule} from 'ng-apexcharts';
import {NgxTimeSchedulerModule} from 'ngx-time-scheduler';
import {StageViewComponent} from './stage-view/stage-view.component';
import {StageEditComponent} from './stage-edit/stage-edit.component';
import {TaskViewComponent} from './task-view/task-view.component';
import {TaskEditComponent} from './task-edit/task-edit.component';
import {TaskModalComponent} from './task-modal/task-modal.component';
// import {NgxIntlTelInputModule} from 'ngx-intl-tel-input';


@NgModule({
    declarations: [
        ProjectsComponent,
        ProjectCreateEditComponent,
        ProjectsListComponent,
        ProjectViewComponent,
        StageViewComponent,
        StageEditComponent,
        TaskViewComponent,
        TaskEditComponent,
        TaskModalComponent
    ],
    exports: [
        TaskViewComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        ProjectsRoutingModule,
        DataTablesModule,
        TranslateModule,
        ReactiveFormsModule,
        NgSelect2Module,
        InlineSVGModule,
        FormsModule,
        NgbAlertModule,
        SharedModule,
        MatTabsModule,
        NgWizardModule,
        NgbTooltipModule,
        NgApexchartsModule,
        NgxTimeSchedulerModule,
        NgbDropdownModule,
        // NgxIntlTelInputModule
    ]
})
export class ProjectsModule {
}
